
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle, Clock, AlertCircle } from 'lucide-react';
import ConsumerConsumptionChart from '@/components/ConsumerConsumptionChart';
import UsageChart from '@/components/UsageChart';

const BillsSummary = () => {
  return (
    <>
      <Card className="mb-6">
        <CardHeader>
          <CardTitle className="text-lg font-semibold">Energy Usage Overview</CardTitle>
        </CardHeader>
        <CardContent>
          <UsageChart utilityType="energy" />
        </CardContent>
      </Card>
      
      <Card className="mb-6">
        <CardHeader>
          <CardTitle className="text-lg font-semibold">Consumption Summary</CardTitle>
        </CardHeader>
        <CardContent>
          <ConsumerConsumptionChart userId="current-user" />
        </CardContent>
      </Card>
      
      <Card>
        <CardHeader>
          <CardTitle className="text-lg font-semibold">Payment Status</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <CheckCircle className="h-5 w-5 text-green-500 mr-2" />
                <span>Paid</span>
              </div>
              <span className="font-medium">3</span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <Clock className="h-5 w-5 text-amber-500 mr-2" />
                <span>Unpaid</span>
              </div>
              <span className="font-medium">1</span>
            </div>
            <div className="flex items-center justify-between">
              <div className="flex items-center">
                <AlertCircle className="h-5 w-5 text-red-500 mr-2" />
                <span>Overdue</span>
              </div>
              <span className="font-medium">0</span>
            </div>
            
            <div className="pt-4 mt-4 border-t">
              <div className="flex justify-between items-center mb-2">
                <span className="text-sm text-gray-500">Next bill estimated:</span>
                <span className="font-medium">$122.50</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-sm text-gray-500">Due date:</span>
                <span className="font-medium">June 15, 2023</span>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </>
  );
};

export default BillsSummary;
